// The section order of the release command center (shots 09–16).
// The numbered strip, the Prev/Next pager, and the route table all read this ONE list so they can never disagree.
// Section 01 Overview · 02 Assets · 03 To-do · 04 Smart Link · 05 Live Ads · 06 Details · 07 Timeline · 08 Budget.
// (Press — the CD `cd-releases` addition — was REMOVED per Ryan, ART-201.)

export type ReleaseSectionKey =
  | "overview"
  | "assets"
  | "todo"
  | "smart-link"
  | "ads"
  | "details"
  | "timeline"
  | "budget";

export interface ReleaseSectionDef {
  key: ReleaseSectionKey;
  /** Two-digit strip number (01–08). */
  num: string;
  label: string;
}

export const RELEASE_SECTIONS: ReleaseSectionDef[] = [
  { key: "overview", num: "01", label: "Overview" },
  { key: "assets", num: "02", label: "Assets" },
  { key: "todo", num: "03", label: "To-do" },
  { key: "smart-link", num: "04", label: "Smart Link" },
  { key: "ads", num: "05", label: "Live Ads" },
  { key: "details", num: "06", label: "Details" },
  { key: "timeline", num: "07", label: "Timeline" },
  { key: "budget", num: "08", label: "Budget" },
];

/** The default section a bare `/releases/:id` deep-link resolves to. */
export const DEFAULT_SECTION: ReleaseSectionKey = "overview";

/**
 * The sections VISIBLE for this seat. `canSeeMarketingMoney` drops **08 Budget**, which is money end to end —
 * line amounts, total, funding, spent, remaining — and is served as an absent block to a seat without
 * `money:marketing` (six seeded roles author release copy holding none). Dropping the tab rather than leaving
 * one that can only render a refusal: an affordance whose single outcome is "not yours" is the dead button
 * this codebase removes everywhere else. Defaults TRUE so the existing call sites and tests keep the full
 * strip; the shell, the only caller that can read a capability, passes the real answer.
 *
 * (Was `sectionsForType` — Press was the one release-TYPE gate, and it is gone.)
 */
export function visibleSections(canSeeMarketingMoney = true): ReleaseSectionDef[] {
  return RELEASE_SECTIONS.filter((s) => !(!canSeeMarketingMoney && s.key === "budget"));
}

/** The display label for a section key ("budget" → "Budget") — used off the full set (e.g. a gated-section notice). */
export function sectionLabel(key: ReleaseSectionKey): string {
  return RELEASE_SECTIONS.find((s) => s.key === key)?.label ?? key;
}
